module.exports = __webpack_public_path__ + "img/icon_attribute_cool.1cbb039b.png";